import { api } from 'API';
import { addImposterToUrl } from 'Utils';

const baseUrl = '/users';

export interface UserData {
  firstName: string;
  lastName: string;
  caseNumber: string;
  israeliId: string;
  district: string;
  email: string;
  getFullMainPhone: string;
}

export interface User {
  authenticatedUser: Partial<UserData>;
  fakeUser?: Partial<UserData>;
  isAdminAuthenticatedUser: boolean;
  hasUnreadedNotifications: boolean;
}

export const getUser = async () => {
  const users = await api.get<User>(addImposterToUrl(baseUrl, true));
  if (users.data) {
    return users.data;
  }
};
